import { Link, useNavigate } from 'react-router-dom';
import { useAuthHeader, useAuthUser } from 'react-auth-kit';
import User from '../../Models/User';

import Logo from "../../Assets/EBCallLogo.png";
import { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import datas from '../../Assets/data.json'
import env from 'react-dotenv';
import { Crypter } from '../../Functions/Security/Crypter';
import { getDominantColor, shadeHex } from '../../Functions/Color/adaptiveColor';
import { queueHub, HubStatus } from '../../Services/signalr';
import speech from '../Fonctions/speech';
import { loadConfigAnnonce, annoncerAppel, AnnonceConfig } from '../../Functions/annonces';
import { useAlert, IconButton } from '../ui';
import CarouselCustom from '../CarousselCustom';
import {
    LayoutGrid,
    Rows,
    PanelRight,
    ArrowLeftRight,
    Loader2,
    Megaphone,
    Hourglass,
    Palette,
    RotateCcw,
    Sun,
    Moon,
    X,
} from 'lucide-react';

/** Durée de mise en avant d'un nouvel appel (ms). */
const FEATURE_DURATION = 12000;

/**
 * LiveScreenPro — affichage TV nouvelle génération.
 * Concept « tableau de départs » : canvas sombre, halos colorés tenant,
 * appel héros animé, guichets en lignes style aéroport, pub encadrée.
 */
const LiveScreenPro = () => {
    const auth = useAuthUser()
    const user: User = JSON.parse(JSON.stringify(auth() || {}))
    const authHeader = useAuthHeader()
    const alert = useAlert();
    const Navigate = useNavigate()

    const [date, setDate] = useState("")
    const [Caisses, setCaisses] = useState<any[]>([])
    const [CaissesNext, setCaissesNext] = useState<any[]>([])
    const [Pub, setPub] = useState<any[]>([])
    const [loading, setLoading] = useState(true)

    const [colors, setColors] = useState("#4338CA|#3730A3")
    const [Text1, setText1] = useState("")
    const [Text2, setText2] = useState("")
    const [logo, setLogo] = useState("")
    const [name, setName] = useState("")

    // Statut connexion SignalR (badge EN DIRECT)
    const [hubStatus, setHubStatus] = useState<HubStatus>('off')
    const [pubColor, setPubColor] = useState<string | null>(null)

    function onPubSlideChange(index: number) {
        const item: any = Pub[index]
        if (item?.type === 'image') {
            getDominantColor(item.src).then(setPubColor)
        } else {
            setPubColor(null)
        }
    }

    const [layout, setLayout] = useState<'split' | 'board' | 'pub'>('split')
    const [swapped, setSwapped] = useState(false)
    const [showControls, setShowControls] = useState(false)

    // Personnalisation des couleurs (prioritaire sur celles du tenant)
    const [accA, setAccA] = useState<string | null>(() => {
        try { return JSON.parse(localStorage.getItem('eb-lsp-colors') || '[]')[0] || null } catch { return null }
    })
    const [accB, setAccB] = useState<string | null>(() => {
        try { return JSON.parse(localStorage.getItem('eb-lsp-colors') || '[]')[1] || null } catch { return null }
    })
    const [paletteOpen, setPaletteOpen] = useState(false)

    // Thème de l'écran : 'dark' | 'light' (persisté)
    const [mode, setMode] = useState<'dark' | 'light'>(() =>
        (localStorage.getItem('eb-lsp-mode') as 'dark' | 'light') || 'dark')
    function applyMode(m: 'dark' | 'light') {
        setMode(m)
        localStorage.setItem('eb-lsp-mode', m)
    }

    function applyColors(a: string | null, b: string | null) {
        setAccA(a)
        setAccB(b)
        if (a || b) localStorage.setItem('eb-lsp-colors', JSON.stringify([a, b]))
        else localStorage.removeItem('eb-lsp-colors')
    }

    /* ---------- Détection du nouvel appel ---------- */
    const prevCaisses = useRef<any[]>([])
    const [featuredBox, setFeaturedBox] = useState<string | null>(null)
    const featuredTimer = useRef<any>(null)
    // Message d'appel courant (mfr du hub) + compteur pour rejouer l'animation
    const [callMsg, setCallMsg] = useState<string | null>(null)
    const [callSeq, setCallSeq] = useState(0)
    const msgTimer = useRef<any>(null)
    const msgEnTimer = useRef<any>(null)

    // Config d'annonce (VOIX_APPEL + MODE_ANNONCE) — résolue pour l'agence/service
    const annonceCfg = useRef<AnnonceConfig>({ vitesse: 1, mode: 'CENTRALISE' })

    /** Affiche le message d'appel (FR puis EN, calé sur l'annonce vocale), puis efface. */
    function showCallMsg(fr: string | null, en?: string | null) {
        setCallMsg(fr)
        if (msgTimer.current) clearTimeout(msgTimer.current)
        if (msgEnTimer.current) clearTimeout(msgEnTimer.current)
        if (fr) {
            // La voix EN suit la FR (~4.5s) → le message affiché bascule en anglais
            if (en) msgEnTimer.current = setTimeout(() => setCallMsg(en), 4500)
            msgTimer.current = setTimeout(() => setCallMsg(null), FEATURE_DURATION)
        }
    }

    useEffect(() => {
        const prev = prevCaisses.current
        const changed = Caisses.find((c: any) => {
            const p = prev.find((o: any) => o.NumBox === c.NumBox)
            return c.NumTicket && (!p || p.NumTicket !== c.NumTicket)
        })
        prevCaisses.current = Caisses
        if (changed) {
            setFeaturedBox(changed.NumBox)
            if (featuredTimer.current) clearTimeout(featuredTimer.current)
            featuredTimer.current = setTimeout(() => setFeaturedBox(null), FEATURE_DURATION)
        }
    }, [Caisses])

    const featured = Caisses.find((c: any) => c.NumBox === featuredBox)
        || Caisses.find((c: any) => c.NumTicket)
        || null
    // Toutes les caisses restent dans la liste — le héros ne fait que mettre en
    // évidence l'appel le plus récent (featuredBox).
    const rowsCaisses = Caisses

    /* ------------------------------- API ------------------------------- */
    function loadInformarions() {
        setLoading(true)
        axios.request({
            method: 'get',
            maxBodyLength: Infinity,
            url: env.API_BASE_URL + datas.API_LINKs.Abonnes + Crypter.encrypt(user.CodeU),
            headers: { 'Accept': 'text/plain', 'Authorization': authHeader() },
        })
            .then((response: any) => {
                const res = JSON.parse(Crypter.decrypt(response.data)).Value
                if (res.StatutCode == 200) {
                    setLoading(false)
                    setName(res.Result[0].Libelle)
                    setColors(res.Result[0].colors)
                    setText1(res.Result[0].Text1)
                    setText2(res.Result[0].Text2)
                    setLogo(res.Result[0].Picture)
                }
                else {
                    Navigate('/')
                    alert.warning(res.Message)
                }
            })
            .catch((error: any) => {
                Navigate('/')
                alert.error('Error', error)
                setLoading(false)
            });
    }

    function loadPub() {
        axios.request({
            method: 'get',
            maxBodyLength: Infinity,
            url: env.API_BASE_URL + datas.API_LINKs.Pub.PubLive + '?CipherCodeS=' + Crypter.encrypt(user.CodeS),
            headers: { 'Accept': 'text/plain', 'Authorization': authHeader() },
        })
            .then((response: any) => {
                const res = JSON.parse(Crypter.decrypt(response.data)).Value
                if (res.StatutCode == 200) {
                    var data: any = []
                    res.Result[0].map((res: any) => {
                        // FIchiers = JSON array de médias ou dataURL seul
                        let fichiers: string[] = []
                        try {
                            const p = JSON.parse(res.FIchiers)
                            fichiers = Array.isArray(p) ? p : [res.FIchiers]
                        } catch { fichiers = [res.FIchiers] }
                        fichiers.forEach((f: string) => {
                            data.push({
                                type: f.split(';')[0].split(':')[1].split("/")[0],
                                src: f,
                                videoRef: data.length
                            })
                        })
                    })
                    setPub(data)
                }
            })
            .catch(() => { });
    }

    function LoadScreem() {
        let data = {
            CodeS: user.CodeS,
            CodeU: user.CodeU,
            CodeFiliale: user.CodeFiliale,
            CodeAbonne: user.CodeAbonne
        }
        axios.request({
            method: 'get',
            maxBodyLength: Infinity,
            url: env.API_BASE_URL + datas.API_LINKs.LiveScreem
                .replaceAll("{User}", Crypter.encrypt(JSON.stringify(data))),
            headers: { 'Accept': 'text/plain' },
        })
            .then((response) => {
                if (response) {
                    let res = JSON.parse(Crypter.decrypt(response.data)).Value;
                    if (res.StatutCode == 200) {
                        setCaisses(res.Result[1])
                        setCaissesNext(res.Result[2])
                    }
                }
            })
            .catch(() => { });
    }

    useEffect(() => {
        loadInformarions()
        loadPub()
        LoadScreem() // chargement initial — GetLiveScreem, puis SignalR prend le relais
        // Config d'annonce vocale — rechargée périodiquement (l'agent peut la changer)
        const loadCfg = () => loadConfigAnnonce(authHeader, user.CodeFiliale, user.CodeS)
            .then((c) => { annonceCfg.current = c })
            .catch(() => { })
        loadCfg()
        const cfgTimer = setInterval(loadCfg, 5 * 60 * 1000)
        return () => clearInterval(cfgTimer)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        const clock = setInterval(() => {
            setDate((new Date(Date.now())).toLocaleTimeString('fr-FR'))
        }, 1000)
        return () => {
            clearInterval(clock)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    // SignalR /hubs/queue — REST initial une fois, puis événements temps réel.
    // Payloads en clair, dedup par eventId géré dans le service.
    useEffect(() => {
        const getJwt = () => (authHeader() || '').replace(/^Bearer\s+/i, '')
        const scope = { codeAbonne: user.CodeAbonne, codeFiliale: user.CodeFiliale, codeS: user.CodeS }

        queueHub.acquire(getJwt, scope).catch(() => setHubStatus('closed'))

        const unsubs = [
            queueHub.onStatus(setHubStatus),
            // État complet de la file — remplace le state, aucun re-fetch REST
            queueHub.on('QueueSnapshot', (p: any) => {
                if (p?.file) {
                    setCaissesNext(p.file.map((f: any) => ({ CodeT: f.codeT })))
                }
                if (p?.numeroEnCours) {
                    setCaisses((prev) => {
                        const exists = prev.some((c: any) => String(c.NumBox) === String(p.numBoxEnCours))
                        return exists
                            ? prev.map((c: any) => String(c.NumBox) === String(p.numBoxEnCours) ? { ...c, NumTicket: p.numeroEnCours } : c)
                            : [...prev, { NumBox: p.numBoxEnCours, NumTicket: p.numeroEnCours }]
                    })
                }
            }),
            // Appel : annonce vocale si le mode le permet (CENTRALISE/LES_DEUX),
            // à la vitesse configurée — le message s'affiche dans tous les cas.
            queueHub.on('TicketCalled', (p: any) => {
                annoncerAppel('live', p?.mfr, p?.men, annonceCfg.current, p?.vitesseAppel ?? p?.VitesseAppel)
                // Message temporaire FR→EN + séquence → animation rejouée à CHAQUE appel
                showCallMsg(p?.mfr || p?.men || null, p?.men || null)
                setCallSeq((s) => s + 1)
            }),
            // Signaux légers → re-fetch REST de la file complète (caisses)
            queueHub.on('FileUpdated', () => LoadScreem()),
            // Décisions sur ticket (validé/rejeté/transféré/absent/annulé) → l'écran
            // se met à jour : refresh REST + on efface la bannière d'appel.
            queueHub.on('TicketValidated', () => { showCallMsg(null); LoadScreem() }),
            queueHub.on('TicketRejected', () => { showCallMsg(null); LoadScreem() }),
            queueHub.on('TicketTransferred', () => { showCallMsg(null); LoadScreem() }),
            queueHub.on('TicketNoShow', () => { showCallMsg(null); LoadScreem() }),
            queueHub.on('TicketCancelled', () => { showCallMsg(null); LoadScreem() }),
        ]

        return () => {
            unsubs.forEach((u) => u())
            queueHub.release()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const [c1, c2] = colors.split('|')
    // Priorité : couleur dominante de la pub affichée > personnalisation > tenant.
    // En vue "board" (pas de pub visible), la couleur pub n'est pas appliquée.
    const pubVisible = layout !== 'board'
    const accent = (pubVisible && pubColor) || accA || c1 || '#4338CA'
    const accent2 = (pubVisible && pubColor ? shadeHex(pubColor, -35) : null) || accB || c2 || '#3730A3'

    /** Presets bicolores pour la palette rapide. */
    const PRESETS: [string, string][] = [
        ['#6366F1', '#4338CA'],
        ['#10B981', '#047857'],
        ['#F43F5E', '#BE123C'],
        ['#F59E0B', '#B45309'],
        ['#06B6D4', '#0369A1'],
        ['#A855F7', '#7E22CE'],
    ]

    /* --------------------- Panneau tableau (file) --------------------- */
    const boardPanel = (
        <aside className={`eb-lsp-board${layout === 'board' ? ' is-full' : ''}`}>
            {/* Héros — appel en cours : le message d'appel uniquement.
                key=callSeq → le héros se remonte et l'animation rejoue à chaque appel. */}
            {callMsg ? (
                <div key={callSeq} className="eb-lsp-now is-new"
                    style={{ borderColor: 'color-mix(in srgb, var(--lsp-a) 40%, transparent)', background: 'linear-gradient(160deg, color-mix(in srgb, var(--lsp-a) 12%, transparent), rgba(255,255,255,.05))' }}>
                    <div className="eb-lsp-now-head">
                        <Megaphone size={16} style={{ color: 'var(--lsp-a)' }} />
                        <span>Appel en cours</span>
                    </div>
                    <p className="eb-lsp-now-msg">{callMsg}</p>
                </div>
            ) : (
                <div className="eb-lsp-now is-idle">
                    <div className="eb-lsp-now-head">
                        <Hourglass size={15} />
                        <span>En attente du prochain appel…</span>
                    </div>
                </div>
            )}

            {/* Guichets — lignes style tableau de départs */}
            <div className="eb-lsp-rows">
                <div className="eb-lsp-rows-head">
                    <span>Box</span>
                    <span>Client</span>
                </div>
                {rowsCaisses.length === 0 && (
                    <div className="eb-lsp-row is-empty"><span>—</span><span>…</span></div>
                )}
                {rowsCaisses.map((c: any, i: number) => (
                    <div key={i} className={`eb-lsp-row${c.NumTicket ? ' is-on' : ''}${featuredBox === c.NumBox && c.NumTicket ? ' is-new' : ''}`}>
                        <span className="eb-lsp-row-box">
                            <i className="eb-lsp-dot" style={{ background: c.NumTicket ? 'var(--lsp-a)' : 'rgba(148,163,184,.4)' }} />
                            {c.NumBox}
                        </span>
                        <span className="eb-lsp-row-ticket">{c.NumTicket || '—'}</span>
                    </div>
                ))}
            </div>

            {/* Prochains appels */}
            <div className="eb-lsp-next">
                <span className="eb-lsp-next-label">Suivants</span>
                <div className="eb-lsp-next-row">
                    {CaissesNext.length === 0 && <span className="eb-lsp-next-none">—</span>}
                    {CaissesNext.map((c: any, i: number) => (
                        <span key={i} className="eb-lsp-next-chip"
                            style={{ animationDelay: `${i * 70}ms`, borderColor: 'color-mix(in srgb, var(--lsp-a) 27%, transparent)', background: 'color-mix(in srgb, var(--lsp-a) 8%, transparent)' }}>{c.CodeT}</span>
                    ))}
                </div>
            </div>
        </aside>
    )

    /* ------------------------- Panneau pub ------------------------- */
    const pubPanel = (
        <section className="eb-lsp-stage" style={{ width: layout === 'split' ? '62%' : '100%' }}>
            <div className="eb-lsp-stage-frame"
                style={{ background: 'linear-gradient(150deg, color-mix(in srgb, var(--lsp-pub) 55%, #0d1220), color-mix(in srgb, var(--lsp-pub) 30%, #0d1220))' }}>
                {Pub.length > 0 ? (
                    <CarouselCustom items={Pub} onSlideChange={onPubSlideChange} />
                ) : (
                    <div className="eb-lsp-stage-empty">
                        <img width={220} src={Logo} alt="" />
                        <div className="eb-lsp-stage-loading">
                            <Loader2 size={26} className="animate-spin" />
                            <span>Chargement des publicités…</span>
                        </div>
                    </div>
                )}
            </div>
        </section>
    )

    const leftPanel = swapped ? boardPanel : pubPanel
    const rightPanel = swapped ? pubPanel : boardPanel

    return (
        <div
            className={`eb-lsp${mode === 'light' ? ' is-light' : ''}`}
            style={{
                // Variables enregistrées @property : les changements de couleur sont animés (fondu)
                ['--lsp-a' as any]: accent,
                ['--lsp-b' as any]: accent2,
                // Couleur dominante de la pub courante — teinte le cadre (letterbox ambiant)
                ['--lsp-pub' as any]: pubColor || '#0d1220',
                background:
                    `radial-gradient(130% 110% at 0% 0%, color-mix(in srgb, var(--lsp-a) ${mode === 'light' ? 25 : 20}%, transparent), transparent 55%),` +
                    `radial-gradient(130% 110% at 100% 100%, color-mix(in srgb, var(--lsp-b) ${mode === 'light' ? 24 : 18}%, transparent), transparent 55%),` +
                    `radial-gradient(90% 70% at 60% 45%, color-mix(in srgb, var(--lsp-a) ${mode === 'light' ? 12 : 8}%, transparent), transparent 60%),` +
                    (mode === 'light' ? '#eef1f7' : '#070a13'),
            }}
            onMouseMove={(e) => {
                if (e.clientY < 60) setShowControls(true)
                else if (e.clientY > 120) setShowControls(false)
            }}
        >
            {/* Halos colorés tenant */}
            <span className="eb-lsp-glow g1" style={{ background: 'radial-gradient(closest-side, color-mix(in srgb, var(--lsp-a) 30%, transparent), transparent 72%)' }} />
            <span className="eb-lsp-glow g2" style={{ background: 'radial-gradient(closest-side, color-mix(in srgb, var(--lsp-b) 26%, transparent), transparent 72%)' }} />
            <span className="eb-lsp-glow g3" style={{ background: 'radial-gradient(closest-side, color-mix(in srgb, var(--lsp-a) 20%, transparent), transparent 72%)' }} />

            {!loading ? (
                <>
                    {/* Barre flottante : marque + direct + horloge */}
                    <header className="eb-lsp-bar">
                        <div className="eb-lsp-bar-brand">
                            {logo && <img src={logo} alt={name} className="eb-lsp-bar-logo" />}
                            <div className="eb-lsp-bar-text">
                                {Text1 && <span className="eb-lsp-bar-t1">{Text1}</span>}
                                {name && <span className="eb-lsp-bar-name">{name}</span>}
                            </div>
                        </div>
                        <div className="eb-lsp-bar-right">
                            <span
                                className={`eb-lsp-live is-${hubStatus}`}
                                title={hubStatus === 'closed' ? 'Cliquer pour reconnecter' : undefined}
                                onClick={hubStatus === 'closed' ? () => queueHub.reconnect() : undefined}
                                style={hubStatus === 'closed' ? { cursor: 'pointer' } : undefined}
                            >
                                <i />
                                {hubStatus === 'connected' ? 'EN DIRECT'
                                    : hubStatus === 'reconnecting' ? 'RECONNEXION…'
                                        : hubStatus === 'closed' ? 'HORS LIGNE'
                                            : 'EN DIRECT'}
                            </span>
                            <div className="eb-lsp-clock">
                                <span className="eb-lsp-clock-time">{date}</span>
                                <span className="eb-lsp-clock-date">{new Date().toLocaleDateString('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' })}</span>
                            </div>
                        </div>
                    </header>

                    {/* Corps */}
                    <main className="eb-lsp-main">
                        {layout === 'split' && (
                            <>
                                {leftPanel}
                                {rightPanel}
                            </>
                        )}
                        {layout === 'board' && boardPanel}
                        {layout === 'pub' && pubPanel}
                    </main>

                    {/* Ticker bas */}
                    {Text2 && (
                        <footer className="eb-lsp-ticker">
                            <span className="eb-lsp-ticker-tag">INFO</span>
                            <div className="marquee-rtl"><div>{Text2}</div></div>
                        </footer>
                    )}

                    {/* Contrôles (survol haut) */}
                    <div className={`eb-livescreem-controls${showControls ? ' is-visible' : ''}`}>
                        <IconButton tooltip="Vue partagée" size={36}
                            color={layout === 'split' ? 'primary' : 'default'}
                            onClick={() => setLayout('split')}>
                            <LayoutGrid size={18} />
                        </IconButton>
                        <IconButton tooltip="Tableau des appels en plein écran" size={36}
                            color={layout === 'board' ? 'primary' : 'default'}
                            onClick={() => setLayout('board')}>
                            <Rows size={18} />
                        </IconButton>
                        <IconButton tooltip="Publicités en plein écran" size={36}
                            color={layout === 'pub' ? 'primary' : 'default'}
                            onClick={() => setLayout('pub')}>
                            <PanelRight size={18} />
                        </IconButton>
                        <div className="eb-livescreem-controls-divider" />
                        <IconButton tooltip="Inverser les positions" size={36}
                            onClick={() => setSwapped(!swapped)}
                            disabled={layout !== 'split'}>
                            <ArrowLeftRight size={18} />
                        </IconButton>
                        <div className="eb-livescreem-controls-divider" />
                        <IconButton tooltip="Personnaliser les couleurs" size={36}
                            color={paletteOpen ? 'primary' : 'default'}
                            onClick={() => setPaletteOpen(!paletteOpen)}>
                            <Palette size={18} />
                        </IconButton>
                    </div>

                    {/* Palette de personnalisation des couleurs */}
                    {paletteOpen && (
                        <div className="eb-lsp-palette" onMouseDown={(e) => e.stopPropagation()}>
                            <div className="eb-lsp-palette-head">
                                <Palette size={14} />
                                <span>Couleurs de l'écran</span>
                                <button type="button" className="eb-lsp-palette-close" title="Fermer"
                                    onClick={() => setPaletteOpen(false)}>
                                    <X size={14} />
                                </button>
                            </div>
                            {/* Thème clair / sombre */}
                            <div className="eb-lsp-mode">
                                <button type="button"
                                    className={`eb-lsp-mode-btn${mode === 'light' ? ' active' : ''}`}
                                    onClick={() => applyMode('light')}>
                                    <Sun size={14} /> Clair
                                </button>
                                <button type="button"
                                    className={`eb-lsp-mode-btn${mode === 'dark' ? ' active' : ''}`}
                                    onClick={() => applyMode('dark')}>
                                    <Moon size={14} /> Sombre
                                </button>
                            </div>
                            <div className="eb-lsp-palette-presets">
                                {PRESETS.map(([a, b]) => (
                                    <button
                                        key={a + b}
                                        type="button"
                                        className="eb-lsp-preset"
                                        style={{ background: `linear-gradient(135deg, ${a}, ${b})` }}
                                        title={`${a} / ${b}`}
                                        onClick={() => applyColors(a, b)}
                                    />
                                ))}
                            </div>
                            <div className="eb-lsp-palette-pickers">
                                <label>
                                    Accent
                                    <input type="color" value={accent} onChange={(e) => applyColors(e.target.value, accB)} />
                                </label>
                                <label>
                                    Halo
                                    <input type="color" value={accent2} onChange={(e) => applyColors(accA, e.target.value)} />
                                </label>
                            </div>
                            <button className="eb-lsp-palette-reset" type="button" onClick={() => applyColors(null, null)}>
                                <RotateCcw size={13} /> Couleurs du tenant
                            </button>
                        </div>
                    )}
                </>
            ) : (
                <div className="eb-livescreem-loading">
                    <img width={300} src={Logo} alt="" />
                    <div className="eb-livescreem-loading-text">
                        <Loader2 size={32} className="animate-spin" style={{ color: 'rgb(25, 7, 143)' }} />
                        <label>Chargement du Live Screen</label>
                        <Link className="eb-livescreem-cancel" to={"/"}>Annuler</Link>
                    </div>
                </div>
            )}
        </div>
    );
};

export default LiveScreenPro;
